import { useState } from "react";
import TableBuySellVolume from "./TableBuySellVolume";
import TableBuySellDelta from "./TableBuySellDelta";

export default function SimulationCumulatedVolumeAnalysis({
  selectedBlock,
  refreshKey,
  setError,
  setUniqueTargetDate,
  activeChartTab = "Buy/Sell",
  sharedData,
  sharedView,
  sharedDeltaData,
  sharedDeltaView,
  selectedExchanges,
  selectedMarkets,
  selectedEntities = [],
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
  setUniqueTargetDate?: any;
  activeChartTab?: string;
  sharedData?: any;
  sharedView?: "buyers" | "sellers";
  sharedDeltaData?: any;
  sharedDeltaView?: "drawal" | "injection";
  selectedExchanges?: string[];
  selectedMarkets?: string[];
  selectedEntities?: { value: string; label: string }[];
}) {
  const [loading, setLoading] = useState(false);

  return (
    <div className="dash-card !border !border-[#DFEAF2] bg-white w-full h-full rounded-2xl overflow-hidden !p-0 !min-h-[200px]">
      {activeChartTab === "Buy/Sell" && (
        <TableBuySellVolume
          loading={loading}
          data={sharedData}
          viewType={sharedView}
          selectedExchanges={selectedExchanges}
          selectedMarkets={selectedMarkets}
          selectedEntities={selectedEntities}
        />
      )}
      {activeChartTab === "Buy/Sell Delta" && (
        <TableBuySellDelta
          loading={loading}
          data={sharedDeltaData}
          viewType={sharedDeltaView}
          selectedExchanges={selectedExchanges}
          selectedMarkets={selectedMarkets}
        />
      )}
    </div>
  );
}
